import React, { useContext } from "react";
import { GameForCard } from "../../../graphql/queries/games/_common.js";
import { Content } from "../../layout/CommonContentContextProvider.js";
import { gaRecommendedClick } from "../../../helpers/googleAnalytics.js";
import GameSummaryBadge from "./GameSummaryBadge.js";
import Card from "../../common/Card.js";
import { FeedContainerGrid } from "../../common/FeedContainers.js";
import { title } from "./RecommendedGames.css.js";
import { urlPathFromTypename } from "../../../../_common/utils.js";

interface Props {
    cpath: string;
    recommendedGames: GameForCard[] | null;
}
const RecommendedGames: React.FC<Props> = ({ cpath, recommendedGames }) => {
    const {
        langCode,
        quizPage: { featuredQuizzesTitle },
    } = useContext(Content);
    if (!recommendedGames) return null;
    return (
        <aside>
            <h2 className={title}>{featuredQuizzesTitle}</h2>
            <FeedContainerGrid>
                {recommendedGames.map(
                    ({
                        id,
                        __typename,
                        date,
                        content: { title, metaDescription, image },
                        questionsNumber,
                        avgScore,
                        usersCount,
                    }) => {
                        const pathPrefix = urlPathFromTypename(__typename);
                        return (
                            <Card
                                key={id}
                                title={title}
                                date={date}
                                mediaItem={image}
                                srcSetSizes={{
                                    tablet: 102,
                                    largePhone: 200,
                                }}
                                link={`/${langCode}/${pathPrefix}/${id}`}
                                onClickHandler={() =>
                                    gaRecommendedClick(
                                        pathPrefix as "quiz" | "outcome-quiz",
                                        `/${pathPrefix}/${id}`,
                                        langCode,
                                        cpath,
                                    )
                                }
                                description={metaDescription}
                            >
                                <GameSummaryBadge
                                    questionsNumber={questionsNumber}
                                    avgScore={avgScore}
                                    usersCount={usersCount}
                                />
                            </Card>
                        );
                    },
                )}
            </FeedContainerGrid>
        </aside>
    );
};

export default RecommendedGames;
